// extracted by mini-css-extract-plugin
module.exports = {"svg":"submit_svg__1Qm31","fade-in":"submit_fade-in__cTm-O","path1":"submit_path1__3GBtv","submit":"submit_submit__1oaaW","link":"submit_link__x-sTQ"};